import Link from '@salesforce/retail-react-app/app/components/link'
import {Link as ChakraLink} from '@salesforce/retail-react-app/app/components/shared/ui'

export * from '@salesforce/retail-react-app/app/utils/url'

/**
 * Given a category and the current locale returns an href to the product list page. (for Yellow Rose Categories)
 *
 * @param {Object} category
 * @returns {string}
 */
export const categoryUrlBuilder = (category) =>
    encodeURI(
        (category?.c_alternativeUrl && category?.c_alternativeUrl?.indexOf('.com') !== -1
            ? category?.c_alternativeUrl.split('.com')?.[1]
            : category?.c_alternativeUrl) || category.c_url
    )

/**
 * Given a search term, constructs a search url.
 *
 * @param {string} searchTerm
 * @returns {string}
 */
export const searchUrlBuilder = (isYR, searchTerm) =>
    (isYR ? '/yellow-rose/search?q=' : '/search?q=') + encodeURIComponent(searchTerm)

export const formattedURL = (url, isExternalRedirectionl = false) => {
    const isYRLink = url?.indexOf('/yellow-rose/') !== -1
    const PWALinkUrl = isYRLink
        ? url?.substring(url?.indexOf('/yellow-rose/'))
        : url?.split('.com')?.[1]
    const linkComponent = isExternalRedirectionl ? ChakraLink : Link
    const productUrlFormatted = isExternalRedirectionl
        ? {href: PWALinkUrl, as: linkComponent}
        : {to: PWALinkUrl, as: linkComponent}
    return productUrlFormatted
}
